import backgroundConstruction from "../../assets/backgroundConstructionOpaque.jpg";
import backgroundConstructionWall from "../../assets/constructionWallOpaque.png";
import backgroundBlocksOpaque from "../../assets/blocksSunshine.png";
import lightconBackground from "../../assets/backgroundLightcon.png";

export const FirstContenxt = () => {
    return (<div className="">
        <section className="py-5 section-background-image" style={{ backgroundImage: `url(${backgroundConstruction})` }}>
            <div className="container">
                <h2 className="text-center mb-4" style={{ color: "#fff" }}>EFICIÊNCIA</h2>
                <p className="lead">
                    O sistema construtivo LIGHTCON® foi desenvolvido e patenteado com o objetivo de tornar o canteiro de obras mais eficiente. Os Thermoblocos LC® são alvenaria estrutural, possuem alta resistência e são cerca de 1/3 mais leves do que a alvenaria tradicional. Com toda essa tecnologia, a obra se torna mais enxuta, diminuindo o tempo de execução e gerando economia.
                </p>
            </div>
        </section>
        <section className="py-5 section-background-image" style={{ backgroundImage: `url(${lightconBackground})` }}>
            <div className="container">
                <h2 className="text-center mb-4" style={{ color: "#fff" }}>SUSTENTABILIDADE</h2>
                <p className="lead">
                    A LIGHTCON® tem o compromisso de tornar o canteiro de obra mais sustentável. Sua tecnologia leve causa menos impacto ao solo, elimina cerca de 60% dos resíduos de obra, reduz drasticamente o uso de madeira para estrutura e ainda diminui o uso de água e energia, reduzindo assim o impacto ao meio ambiente.
                </p>
            </div>
        </section>

        <section className="py-5 section-background-image" style={{ backgroundImage: `url(${backgroundConstructionWall})` }}>
            <div className="container">
                <h2 className="text-center mb-4" style={{ color: "#fff" }}>TECNOLOGIA 100% BRASILEIRA</h2>
                <p className="lead">
                    Com olhar na nossa forma de construir, o Sistema Construtivo LIGHTCON® foi desenvolvido de forma a produzir uma obra mais eficiente sem perder a tradicionalidade da mão de obra brasileira. Mantendo forte a tradição da Construção Civil em ser o segundo setor que mais gera emprego no país.
                </p>
            </div>
        </section>

        <section className="py-5 section-background-image" style={{ backgroundImage: `url(${backgroundBlocksOpaque})` }}>
            <div className="container">
                <h2 className="text-center mb-4" style={{ color: "#fff" }}>EMPREENDEDORISMO SOCIAL</h2>
                <p className="lead">
                    A LIGHTCON® é uma empresa comprometida com questões sociais. Nosso negócio é criar um impacto positivo na sociedade, buscando soluções para problemas sociais e ambientais, gerando transformação. Por isso, a LIGHTCON® destina 10% de todos os royalties arrecadados com as vendas dos Thermoblocos LC® a programas de combate à falta de moradias, sabendo que no Brasil há mais de 14 milhões de pessoas em extrema pobreza e sem moradia digna.
                </p>
            </div>
        </section>
    </div>
    );
}